import { useState } from "react";
import { Button } from "reactstrap";

const SecureField = ({ value }: { value: string }) => {
  const [visible, setVisible] = useState(false);

  if (!value) return <span>-</span>;

  return (
    <div className="d-flex align-items-center gap-2">
      <span>{visible ? value : "••••••••"}</span>
      <Button
        color="link"
        size="sm"
        className="p-0"
        onClick={() => setVisible((v) => !v)}
      >
        <i className={`f-20 fa ${visible ? "fa-eye-slash" : "fa-eye"}`} />
      </Button>
    </div>
  );
};

export const secureFieldFormatter =
  <T extends object>() =>
  (value: unknown, _data: T) =>
    <SecureField value={String(value ?? "")} />;
